<template>
  <div>
    <v-row class="form-title" align="center" justify="center"
      ><h2 class="header-title-h2">
        Complimenti per aver scelto il tuo piano di iscrizione.
      </h2></v-row
    >
    <v-row class="form-title" align="center" justify="center">
      <h3 class="header-title-h3">
        Il prossimo passo consiste nello scegliere il tuo nome di dominio.<BR />Puoi
        verificare la disponibilità dello stesso direttamente nel campo
        sottostante.
      </h3>
    </v-row>
    <v-row align="center" justify="center">
      <h3 class="header-title-h3-cyan">
        Prima del pagamento potrai sempre modificare la scelta del dominio
      </h3></v-row
    >
    <div class="form-spacer" />
    <v-form class="form-content">
      <ValidationObserver ref="obs" v-slot="{ invalid, validated }">
        <v-row justify="center">
          <v-col style="max-width:400px">
            <ValidationProvider
              immediate
              :rules="{
                required: true,
                domain: /^[a-z0-9]+([\-]{1}[a-z0-9]+)*$/,
              }"
              v-slot="{ errors, valid }"
            >
              <v-text-field
                v-model="domainName"
                outlined
                hide-details
                :disabled="domainCheckInProgress"
                :error-messages="errors"
                :success="valid"
                label="Dominio"
              ></v-text-field>
            </ValidationProvider>
          </v-col>
          <v-col style="max-width:150px">
            <v-select
              v-model="domainExtension"
              :disabled="domainCheckInProgress"
              outlined
              :items="domainsExtensions"
              label="Estensione"
              hide-details
            />
          </v-col>
        </v-row>

        <v-row class="text-center " align="center" v-if="domainError">
          <v-col
            ><h3 class="error--text">{{ domainError }}</h3></v-col
          >
        </v-row>

        <v-row v-if="domainValid" align="center" justify="center">
          <v-col
            ><h3>
              <v-icon color="success" large>mdi-check</v-icon>Complimenti! Il
              dominio {{ domainCheckName }} è disponibile!
            </h3></v-col
          >
        </v-row>
        <v-row v-if="domainValid" align="center" justify="center">
          <v-col
            ><h3 v-if="$store.state.wizard.meta.feature == 'base'">
              Scegli ora 1 casella di posta da creare insieme al tuo dominio:
            </h3>

            <h3 v-if="$store.state.wizard.meta.feature == 'premium' || $store.state.wizard.meta.feature == 'deluxe'">
              Scegli ora 3 caselle di posta da creare insieme al tuo dominio.
              Puoi anche deciderne di meno, ma per aggiungerne successivamente,
              dovrai contattare il supporto clienti.
            </h3>
          </v-col>
        </v-row>

        <v-card v-if="domainValid" outlined elevation="2">
          <v-card-title class="header-mail">Email principale</v-card-title>
          <v-card-text>
            <v-row dense  align="center" justify="center">
              <v-col style="min-width: 400px; max-width:400px">
                <ValidationProvider
                  rules="alpha_dash|required"
                  v-slot="{ errors, valid }"
                >
                  <v-text-field
                    v-model="email_1"
                    outlined
                    :error-messages="errors"
                    :success="valid"
                    :label="'Nome mail senza @' + domainCheckName"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col style="min-width: 400px; max-width:400px">
                <ValidationProvider
                  rules="required|min:5"
                  v-slot="{ errors, valid }"
                  vid="password_confirm_1"
                >
                  <v-text-field
                    v-model="email_1_password"
                    outlined
                    :error-messages="errors"
                    :success="valid"
                    label="Password"
                    type="password"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col style="min-width: 400px; max-width:400px">
                <ValidationProvider
                  rules="required|confirmed:password_confirm_1"
                  v-slot="{ errors, valid }"
                >
                  <v-text-field
                    v-model="email_1_password_confirm"
                    outlined
                    :error-messages="errors"
                    :success="valid"
                    label="Conferma password"
                    type="password"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <div style="height:20px" />

        <v-card
          v-if="domainValid && ($store.state.wizard.meta.feature == 'premium' || $store.state.wizard.meta.feature == 'deluxe')"
          outlined
          elevation="2"
        >
          <v-card-title class="header-mail"
            >Seconda email facoltativa</v-card-title
          >
          <v-card-text>
            <v-row dense align="center" justify="center">
              <v-col style="min-width: 400px; max-width:400px">
                <ValidationProvider
                  :enabled="email_1"
                  rules="alpha_dash"
                  v-slot="{ errors, valid }"
                  immediate
                >
                  <v-text-field
                    v-model="email_2"
                    outlined
                    :error-messages="errors"
                    :success="valid"
                    :label="'Nome mail senza @' + domainCheckName"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col style="min-width: 400px; max-width:400px">
                <ValidationProvider v-if="email_2"
                  rules="required"
                  v-slot="{ errors, valid }"
                  vid="password_confirm_2"
                >
                  <v-text-field
                    v-model="email_2_password"
                    outlined
                    :error-messages="errors"
                    :success="valid"
                    label="Password"
                    type="password"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col style="min-width: 400px; max-width:400px">
                <ValidationProvider v-if="email_2"
                  rules="required|confirmed:password_confirm_2"
                  v-slot="{ errors, valid }"
                >
                  <v-text-field
                    v-model="email_2_password_confirm"
                    outlined
                    :error-messages="errors"
                    :success="valid"
                    label="Conferma password"
                    type="password"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <div style="height:20px" />

        <v-card
          v-if="domainValid && ($store.state.wizard.meta.feature == 'premium' || $store.state.wizard.meta.feature == 'deluxe')"
          outlined
          elevation="2"
        >
          <v-card-title class="header-mail"
            >Terza email facoltativa</v-card-title
          >
          <v-card-text>
            <v-row dense align="center" justify="center">
              <v-col style="min-width: 400px; max-width:400px">
                <ValidationProvider
                  rules="alpha_dash"
                  v-slot="{ errors, valid }"
                  immediate
                  :enabled="email_2"
                >
                  <v-text-field
                    v-model="email_3"
                    outlined
                    :error-messages="errors"
                    :success="valid"
                    :label="'Nome mail senza @' + domainCheckName"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col style="min-width: 400px; max-width:400px">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors, valid }"
                  v-if="email_3"
                  vid="password_confirm_3"
                >
                  <v-text-field
                    v-model="email_3_password"
                    outlined
                    :error-messages="errors"
                    :success="valid"
                    label="Password"
                    type="password"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col style="min-width: 400px; max-width:400px">
                <ValidationProvider
                  v-if="email_3"
                  rules="required|confirmed:password_confirm_3"
                  v-slot="{ errors, valid }"
                >
                  <v-text-field
                  type="password"
                    v-model="email_3_password_confirm"
                    outlined
                    :error-messages="errors"
                    :success="valid"
                    label="Conferma password"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <div style="height:20px" />

        <v-row class="text-center" align="center" justify="center">
          <v-btn
            class="ml-2"
            @click="checkDomain()"
            color="primary"
            v-if="!domainCheckInProgress && !domainValid"
            :disabled="invalid || !validated"
            >Controlla disponibilità</v-btn
          >

          <v-btn
            class="ml-2"
            v-if="!domainCheckInProgress && !domainSelected"
            @click="goBack()"
            color="primary"
            >Indietro</v-btn
          >

          <v-btn
            class="ml-2"
            v-if="domainValid && !domainSelected"
            @click="confirmDomain($event)"
            color="primary"
            :disabled="invalid || !validated || domainSelected"
            >Passo successivo</v-btn
          >

          <v-progress-circular
            v-if="domainSelected"
            :indeterminate="true"
            :rotate="0"
            :size="32"
            :width="4"
            color="light-blue"
          ></v-progress-circular>
        </v-row>
      </ValidationObserver>
    </v-form>

    <v-row v-if="domainCheckInProgress" align="center" justify="center">
      <h3>Controllo disponibilità del dominio {{ domainCheckName }}</h3>
      <v-progress-circular
        :indeterminate="true"
        :rotate="0"
        :size="32"
        :width="4"
        color="light-blue"
        class="ml-2"
      ></v-progress-circular>
    </v-row>

    <div class="form-spacer" />
  </div>
</template>

<style scoped>
.header-mail {
  color: #74a2bc;
  font-size: 22px;
  font-weight: 400;
}

.header-title-h2 {
  color: #74a2bc;
  font-size: 32px;
  font-weight: 400;
}

.header-title-h3 {
  font-size: 26px;
}

.header-title-h3-cyan {
  color: #74a2bc;
  font-size: 26px;
}

.form-title {
  color: gray;
  font-size: 20px;
  margin: 10px;
}

.form-title-sub {
  color: gray;
  font-size: 16px;
  margin: 10px;
}

.form-title-sub-mini {
  color: gray;
  font-size: 14px;
  margin: 10px;
}

.form-content {
}

.form-spacer {
  height: 30px;
}
</style>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import store from "../../store/index";

import domains from "../../apis/domains";

export default {
  data() {
    return {
      domainSelected: false,
      domainError: null,
      domainName: "dottmariorossi",
      domainCheckInProgress: false,
      domainValid: false,
      domainExtension: ".it",
      domainsExtensions: [".it", ".com", ".eu"],
      domainCheckName: null,
      email_1: null,
      email_2: null,
      email_3: null,
      email_1_password : null ,
      email_1_password_confirm : null,
       email_2_password : null ,
      email_2_password_confirm : null,
      email_3_password : null ,
      email_3_password_confirm : null,
     
    };
  },

  components: {
    ValidationObserver,
    ValidationProvider,
  },

  mounted() {
    let domainName = this.$store.state.wizard.meta
      ? this.$store.state.wizard.meta.domain
      : null;
    let domainExtension = this.$store.state.wizard.meta
      ? this.$store.state.wizard.meta.domainExtension
      : null;
    this.domainCheckName = domainName + domainExtension;
    if (domainName && domainExtension) {
      this.domainName = domainName;
      this.domainExtension = domainExtension;
      this.domainValid = true;
    }

    if (this.$store.state.wizard.meta.email_1)
      this.email_1 = this.$store.state.wizard.meta.email_1;
    if (this.$store.state.wizard.meta.email_2)
      this.email_2 = this.$store.state.wizard.meta.email_2;
    if (this.$store.state.wizard.meta.email_3)
      this.email_3 = this.$store.state.wizard.meta.email_3;

    this.$watch("domainName", function() {
      this.domainValid = false;
      this.domainError = null;
    });

    this.$watch("domainExtension", function() {
      this.domainValid = false;
      this.domainError = null;
    });

    this.$refs.obs.validate();
  },

  methods: {
    checkDomain() {
      this.domainValid = false;
      this.domainError = null;
      this.domainCheckInProgress = true;
      let effectiveDomainName = this.domainName + this.domainExtension;
      if (effectiveDomainName.indexOf("www.") == 0)
        effectiveDomainName = effectiveDomainName.substr(
          4,
          effectiveDomainName.length - 4
        );
      this.domainCheckName = effectiveDomainName;
      domains
        .checkDomain(this.domainCheckName)
        .then((res) => {
          if (res.Availability && res.Availability == "AVAILABLE") {
            this.domainCheckInProgress = false;
            this.domainValid = true;
          } else if (res.Availability) {
            this.domainValid = false;
            this.domainCheckInProgress = false;
            this.domainError =
              "Il dominio " +
              this.domainCheckName +
              " non è disponibile. Provare con un altro nome di dominio!";
          } else {
            this.domainValid = false;
            this.domainCheckInProgress = false;
            this.domainError = res;
          }
        })
        .catch((err) => {
          this.domainError = err;
          this.domainCheckInProgress = false;
          this.domainValid = false;
        });
    },

    confirmDomain() {
      this.domainSelected = true;
      let completedStep = this.$store.state.wizard.completedStep;
      if (completedStep < this.$store.state.wizard.selectedStep)
        completedStep = this.$store.state.wizard.selectedStep;
        
      store
        .dispatch("setWizardSteps", {
          completedStep: completedStep,
          selectedStep: this.$store.state.wizard.selectedStep + 1,
          meta: {
            domain: this.domainName,
            domainExtension: this.domainExtension,
            email_1 : this.email_1,
            email_2 : this.email_2,
            email_3 : this.email_3,
            email_1_password : this.email_1_password,
            email_2_password : this.email_2_password,
            email_3_password : this.email_3_password,
            
          },
        })
        .then(() => {
          this.domainSelected = false;
        });
    },

    goBack() {
      this.$store.state.wizard.selectedStep--;
    },
  },
};
</script>
